import { formatNumberForUrl } from "./format-number-for-url";

export function rangeToUrlSegment(min: number, max: number, prefix: string): string {
	if (min === max) return `${prefix}-${formatNumberForUrl(min, { rounding: "truncate", decimals: 1 })}`;

	const formattedMin = formatNumberForUrl(min, { rounding: "truncate", decimals: 1 });
	const formattedMax = formatNumberForUrl(max, { rounding: "truncate", decimals: 1 });

	if (min === max) return `${prefix}-${formattedMin}`;
	return `${prefix}-${formattedMin}-${formattedMax}`;
}
